"use client";
import { jsx } from "react/jsx-runtime";
import { RadioGroup } from "@base-ui/react/radio-group";
import { useCallback } from "react";
import { useOptimisticSelection } from "../../../hooks/index.js";
import { cn } from "../../../utils/index.js";
import { FilterChip } from "../../FilterChip/FilterChip.js";
import { radioChipGroupVariants } from "./RadioChipGroup.variants.js";
function RadioChipGroup({ name, defaultValue, value, handleChange, className = '', options, disabled, required, layout, ...props }) {
    const { radioChipGroup } = radioChipGroupVariants({
        layout
    });
    const isControlled = void 0 !== value;
    const [selectedValue, setSelectedValue] = useOptimisticSelection(value ?? defaultValue, {
        isControlled,
        initial: value ?? defaultValue
    });
    const handleValueChange = useCallback((newValue, eventDetails)=>{
        setSelectedValue(String(newValue));
        handleChange(newValue, eventDetails?.event);
    }, [
        handleChange,
        setSelectedValue
    ]);
    const classes = cn(radioChipGroup(), className);
    return /*#__PURE__*/ jsx(RadioGroup, {
        disabled: disabled,
        name: name,
        defaultValue: defaultValue,
        value: value,
        onValueChange: handleValueChange,
        className: classes,
        required: required,
        ...props,
        children: options.map((option)=>/*#__PURE__*/ jsx(FilterChip, {
                ...option,
                filterType: "radio",
                disabled: disabled ?? option.disabled,
                selected: selectedValue === String(option.value),
                onClick: ()=>{
                    if (!disabled && !option.disabled) handleValueChange(option.value);
                },
                opens: false
            }, option.value))
    });
}
export { RadioChipGroup };
